import React from 'react';
import {templates} from "./templates";

export default function DisplayTemplate ({templateType, ...props}) {
    const Component = templates[String(templateType).toLowerCase()]

    return Component ? <Component {...props}/> : null;
}